module.exports = __webpack_public_path__ + "static/media/volleyball.ed96d758.svg";